 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		36: 0,
 		47: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"vendors~BulkRoster~ContentAccessLookup~MergeApproval~MergeRequest~OneRosterOrgs","5":"MergeApproval~MergeRequest~UserDash","6":"News","8":"AssignmentContainer","9":"AssignmentsContainer","10":"BulkRoster","11":"ContentAccessLookup","12":"Home","13":"LazyAssignedArticleReviewContainer","14":"LazyCanvasAssignmentReviewContainer","15":"LazySearchComponent","16":"LessonSparkContainer","17":"MergeApproval","18":"MergeRequest","19":"OneRosterOrgs","20":"OpenMergeRequests","21":"ProvisionSchools","22":"Pygmalion","23":"ReadContainer","24":"SignIn","25":"StandaloneAudioTrack","26":"StandaloneExternalEmbed","27":"StandalonePoll","28":"StandaloneVideo","29":"StandardContainer","30":"TeacherBinder","31":"TeacherOnboarding","32":"TextSets","33":"UnitsContainer","34":"UserDash","35":"YourContentContainer","37":"browse"}[chunkId]||chunkId) + "." + {"0":"e73cb1d502e4e6b597c2","1":"42d2963f6d59eff20317","2":"62a7c62adee75474e7d6","3":"60b2b23a4bcd5a164283","4":"7b4d49b924541ee720e5","5":"0df4ba483ff8f124acb3","6":"95d04662fa828f1b066c","7":"29b7b4481ccbd8545c10","8":"bb75b353befc13c0f713","9":"17a50d7ac2c278952b1e","10":"e0f0c77eb796feff4bf8","11":"919375e1b00483a7e9e4","12":"067582c1a3a74df112ab","13":"0f53538e4ff59d324f8d","14":"4e576e6a17b97b54ab24","15":"c595d1cc3ca899236dca","16":"aa46fafb1e67b93190fa","17":"00505800ef9cc7daae45","18":"d8aea706825252119a43","19":"bdc04f7984bf007f918e","20":"9a3fb49df8b851adb2ab","21":"63fc5bc0676e6ad5401a","22":"ab4d1bc00cea0aa2fde6","23":"4f03ce8a19149d1b20b4","24":"bce1fc6ff18e8a34dc2a","25":"9fdbb69bc21d28d98e44","26":"746e995a7f66a8cc7050","27":"c5aebf2245faf0ca7b27","28":"97a589cee5a0ff408914","29":"57e9a51ebe5cf107d791","30":"a82de516502077396d3e","31":"7998443f64e93742bd3d","32":"83702524af88aac7abfe","33":"2e245ded781a1a7070ae","34":"96e65827cfb3546ecc99","35":"3fb2357a337e5f60493d","37":"63cf094f5341f203871c","40":"66b032471ad91aa3a013","41":"a323c5e1ca14e0591f40","42":"c732a2b735f2b7a9c1b9","43":"0980394822518ae2a8b7","44":"20c46bf6bb5e8b482b96","45":"d015a94d67c911b043db","46":"388d034cc73855d51663","47":"732ecaaa54fdad8749e4","48":"743534612682a8468bb1","49":"9d7ef348a9d5516c9b70","50":"4d1e363b8d5c6169ba45","51":"05b22425ffac78ee2a20","52":"b0e5e23ebb005f869cb5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1701);
